export default "__VITE_ASSET___xkdcEL1__"